import Vue from 'vue';
import BrandsBasic from '@/plugins/graphql/queries/v2/b2b/brands-basic.gql';
/**
 * Brands Basic Details Query
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.22.0}
 */
export default Vue.extend({
    apollo: {
        brands: {
            query: BrandsBasic,
            variables() {
                return {
                    appUuid: this.appUuid,
                };
            },
            update(data) {
                return data.brandsByApp.edges.map((n) => n.node);
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            brands: [],
        };
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                brands: this.brands,
            });
        }
    },
});
